import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../services/global.service';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';

@Component({
  selector: 'app-products-specs',
  templateUrl: './products-specs.html',
  styleUrls: ['./products-specs.css']
})
export class ProductsSpecsComponent implements OnInit {

  specsList: any[] = [];
  contentVisible: boolean = false;

  paginationData = {
    count: 300,
    offset: 0,
    count_all: 0,
    currentPage: 1,
    maxPage: 1
  };

  filtersData = {
    name: ''
  };

  all_count: number = 0;

  filtersTimeout: any;

  // availableRoles: string[] = [ 'admin', 'sales', 'manager', 'installer' ];
  isAvailable: boolean = true;


  constructor ( 
    private model: ModelService,
    private global: GlobalService,
    private loginService: LoginService ) {
    this.global.setDocumentTitle( 'Product Specs' ); 
    // if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    // else this.isAvailable = true;
  }

  ngOnInit ( ) {
  }

  ngAfterViewInit ( ) {
    this.loadData( );
  }


  loadData ( _withoutPreloader?, cb? ) {
    let requestData = {};
    let withoutPreloader = true;
    if ( _withoutPreloader === false ) withoutPreloader = false;

    requestData['pagination'] = this.paginationData;
    requestData['filters'] = this.filtersData;
    
    this.model.getProductsSpecsData( requestData, ( response ) => {
      this.contentVisible = true;
      this.specsList = response.data;
      if ( response.pagination )  this.paginationData = response.pagination;
      if ( response.filters )     this.filtersData    = response.filters;
      if ( response.all_count )   this.all_count      = response.all_count;
      else {
        if ( response.pagination ) this.all_count = response.pagination.count_all;
        else this.all_count = 0;
      }
      if ( cb ) cb( );
    }, withoutPreloader);
  }

  changeFilters ( clearing?:boolean ) {

    clearTimeout( this.filtersTimeout );
    this.filtersTimeout = setTimeout( ( ) => {
      this.paginationData.offset = 0;
      this.paginationData.currentPage = 1;
      if ( clearing == true ) this.loadData( false );
      else this.loadData( );
    }, 350 );

  }

  clearFilters ( ) {
    this.filtersData = {
      name: ''
    };
    this.changeFilters( true );
  }

  changePage ( page ) {
    this.paginationData.currentPage = page;
    this.paginationData.offset = (page-1) * this.paginationData.count;
    this.loadData( false );
    $('html,body').animate({ scrollTop: 0 }, 'slow');
  }


}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/products/specs/products-specs.ts